import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { setConfig, getConfig } from "@startupp-cloud/startupp-ai-sdk";

// Configure SDK with API base URLs
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.startupp.ai";
const AUTH_BASE_URL =
  process.env.REACT_APP_AUTH_BASE_URL || "https://api.startupp.ai";

// ✅ Production-ready: No console logging
const isDevelopment = process.env.NODE_ENV === "development";

// Initialize SDK configuration
const initializeSDK = () => {
  try {
    // Debug: Log environment variables before SDK configuration
    console.log("[SDK Init] Environment variables:", {
      REACT_APP_APIKEY: process.env.REACT_APP_APIKEY
        ? `${process.env.REACT_APP_APIKEY.substring(
            0,
            8
          )}...${process.env.REACT_APP_APIKEY.substring(
            process.env.REACT_APP_APIKEY.length - 4
          )} (length: ${process.env.REACT_APP_APIKEY.length})`
        : "NOT SET",
      REACT_APP_DEFAULT_ORGANIZATION_ID: process.env
        .REACT_APP_DEFAULT_ORGANIZATION_ID
        ? `${process.env.REACT_APP_DEFAULT_ORGANIZATION_ID.substring(0, 8)}...`
        : "NOT SET",
      NODE_ENV: process.env.NODE_ENV,
    });

    setConfig({
      apiBaseUrl: API_BASE_URL,
      authBaseUrl: AUTH_BASE_URL,
      organizationId: process.env.REACT_APP_DEFAULT_ORGANIZATION_ID,
      apiKey: process.env.REACT_APP_APIKEY,
      environment: process.env.NODE_ENV,
    });

    const currentConfig = getConfig();
    console.log("[SDK Init] SDK configured with:", {
      ...currentConfig,
      apiKey: currentConfig?.apiKey
        ? `${currentConfig.apiKey.substring(
            0,
            8
          )}...${currentConfig.apiKey.substring(
            currentConfig.apiKey.length - 4
          )} (length: ${currentConfig.apiKey.length})`
        : "NOT SET",
    });

    return currentConfig;
  } catch (error) {
    console.error("[SDK Init] Failed to initialize SDK:", error);
    if (!isDevelopment && window.errorReporting) {
      window.errorReporting.captureException(error);
    }
    throw error;
  }
};

// Setup global error handlers
window.addEventListener("unhandledrejection", (event) => {
  const errorMessage = event?.reason?.message || "Unknown promise rejection";
  if (!isDevelopment && window.errorReporting) {
    window.errorReporting.captureException(new Error(errorMessage));
  }
  event.preventDefault();
});

window.addEventListener("error", (event) => {
  const errorMessage = event?.error?.message || "Unknown runtime error";
  if (!isDevelopment && window.errorReporting) {
    window.errorReporting.captureException(new Error(errorMessage));
  }
  event.preventDefault();
});

// Initialize app
try {
  initializeSDK();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  if (!isDevelopment && window.errorReporting) {
    window.errorReporting.captureException(error);
  }
}
